export default __webpack_public_path__ + "static/media/doc3.b04a7105.jpg";